module.exports = __webpack_public_path__ + "img/PT173.47f49be0.svg";